import App from "./App.svelte";
import 'swiper/swiper-bundle.css';
const app = new App({
  target: document.getElementById('beresa-abosite')
});
export default app;
